import { FormattedMessage } from 'react-intl';

import { PremiumTagShell } from './premium-tag-shell';
import shellStyle from './premium-tag-shell.module.css';
import amazonLogo from './amazon-logo.svg';
import { AMAZON_PALLET_DELIVERY_COLOR } from './amazon-pallet-delivery-constants';
import { messages } from './messages';

export const AmazonPalletDeliveryTag = () => {
  return (
    <PremiumTagShell
      color={AMAZON_PALLET_DELIVERY_COLOR}
      logo={<img alt='' className={`${shellStyle['tag-logo']} ${shellStyle['tag-logo-balanced']}`} src={amazonLogo} />}
    >
      <FormattedMessage {...messages.amazonPalletDeliveryLabel} />
    </PremiumTagShell>
  );
};
